import { getPersonSchema } from "@/services/api";

export const addTagSchema = getPersonSchema().pick(["tags"]);
